import { memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Grid, Col } from 'components/grid'
import { DuplicateBillForm } from 'modules/duplicate-bill-form'

import * as S from './styles'

const Hero = memo(() => (
  <S.Hero>
    <Grid col={{ phone: 1, tablet: 2 }}>
      <Col col={{ desktop: 5 }} start={{ desktop: 2 }}>
        <S.Infos>
          <Text as="h1" size="heading2" weight="medium">
            Acesse a{' '}
            <Text as="span" size="heading2" weight="medium" color="var(--colors-pink-text-default)">
              segunda via do seu boleto{' '}
            </Text>
            agora
          </Text>
          <Text size="body1" color="var(--colors-neutral-text-weak)">
            Se você perdeu ou não recebeu o seu boleto, não se preocupe. Agora você pode solicitar a segunda via do seu
            boleto por aqui.
          </Text>
        </S.Infos>
      </Col>
      <Col col={{ desktop: 5 }} start={{ desktop: 7 }}>
        <S.RightWrapper>
          <DuplicateBillForm />
        </S.RightWrapper>
      </Col>
    </Grid>
  </S.Hero>
))

Hero.displayName = 'Hero'

export default Hero
